// Authentication related error messages
export const authErrors = {
  USER_ALREADY_EXISTS: "User already exists",
  LINK_EXPIRED: "Link has expired",
  NO_EXPORT_PERMISSION:
    "You don't have the permission to export processes, please contact your admin.",
  UNKNOWN_ERROR: "Unknown error occurred",
  USER_CREATE_FAILED: "Could not create user. Please try again",
  ORG_CREATE_FAILED: "Could not create org",
  SOMETHING_WENT_WRONG: "Something went wrong",
  INVALID_CREDENTIALS: "Incorrect Username/Password",
  INVALID_EMAIL: "Please enter a valid email address",
  TOO_MANY_ATTEMPTS: "Too many failed login attempts, try again later",
  UNKNOWN: "Unknown error",
  INVALID_PASSWORD: "Error. Please refer to the password requirements",
  ORG_CREATION_FAILED: "Org Creation Failed",
  ORG_EXISTS: "org already exists",
  UNABLE_CREATE_ORG: "Unable to create new org"
};

// File operation related error messages
export const fileOperationErrors = {
  INVALID_FORMAT: "Invalid format uploaded",
  UPLOAD_ERROR: "Error in uploading files",
  DOWNLOAD_ERROR: "Error in downloading file",
  DELETE_ERROR: "Error in deleting file",
  RENAME_ERROR: "Error in renaming file",
  MOVE_ERROR: "Error in moving file",
  CLONE_ERROR: "Error in cloning file",
  PIN_ERROR: "Error in pinning file",
  FETCH_ERROR: "Error in fetching folder",
  CREATE_ERROR: "Error in creating folder",
  VIEW_ERROR: "Error in viewing file",
  UPLOADS_DISABLED: "Your org has disabled file uploads",
  SERVER_UPLOAD_ERROR: "Problem uploading file. Server error",
  APPLICATION_UPLOAD_ERROR:
    "Problem uploading file. The application encountered an error"
};

// Workflow related error messages
export const workflowErrors = {
  LOAD_ERROR: "Error in loading Processes",
  CREATE_ERROR: "Error in creating Process",
  DRAFT_CREATE_ERROR: "Error Creating Draft Process",
  EDIT_ERROR: "Edit Process failure",
  TEMPLATE_CREATE_ERROR: "Error creating process templates",
  DELETE_ERROR: "Error deleting process",
  DELETE_CANCEL_RECORDS: "Deleting process (Cancelling all records)",
  PROCESS_DELETED: "Process was deleted"
};

// Report related error messages
export const reportErrors = {
  CREATE_ERROR: "Error creating report. Please try again.",
  DELETE_ERROR: "Error deleting report",
  CHART_LOAD_ERROR: "Unable to load chart",
  CHART_REFRESH_ERROR: "Refreshed chart data not available"
};

// Settings related error messages
export const settingsErrors = {
  FETCH_ERROR: "Unable to fetch your settings",
  TILE_DELETE_IN_USE: "You can't delete tiles that are being used",
  TILE_DELETE_ERROR: "Unable to delete the tile",
  STATUS_EDIT_ERROR: "Unable to edit status"
};

// Network related error messages
export const networkErrors = {
  OFFLINE: "You are offline",
  ONLINE: "You are back online"
};

// Email related error messages
export const emailErrors = {
  BLOCKED_NOTIFICATION:
    "Email failure to send notification: One or more of the email IDs you've entered is blocked by the admin",
  SEND_ERROR: "Error sending email!",
  SEND_SUCCESS: "Email sent successfully!"
};

// Room management related error messages
export const roomErrors = {
  GROUP_REMOVE_ERROR: "Error in removing room group",
  MEMBER_REMOVE_ERROR: "Error in removing room member",
  MEMBER_ADD_ERROR: "Error in adding room member",
  CREATE_ERROR: "Error in creating chatroom"
};

// Forms related error messages
export const formErrors = {
  INSUFFICIENT_PERMISSION: "You do not have enough permission",
  CREATE_ERROR: "Error creating form",
  CHECKLIST_LOCK_ERROR: "Unable to lock checklist fields",
  OPEN_ERROR: "Error Opening form",
  EDIT_ERROR: "Error editing form",
  FETCH_ERROR: "Error fetching form data",
  UPDATE_CHECKLIST_ERROR: "Unable to update checklist"
};

// User management related error messages
export const userErrors = {
  UPDATE_ERROR: "Unable to update details",
  ADMIN_PROMOTION_ERROR: "Unable to make user admin",
  ADMIN_PROMOTION_SUCCESS: "User is admin now"
};

// Integration related error messages
export const integrationErrors = {
  COMPLETE:
    "The integration has been completed! You will be redirected to Unifize shortly",
  UPDATE_ERROR: "Update integration failed",
  DISCONNECT_ERROR: "Disconnect integration failed"
};

// Dashboard related error messages
export const dashboardErrors = {
  CREATE_ERROR: "Unable to create dashboard",
  TITLE_UPDATE_ERROR: "Unable to change title of the report",
  ADD_CHART_ERROR: "Unable to add chart to dashboard",
  DELETE_ERROR: "Unable to delete dashboard",
  REMOVE_CHART_ERROR: "Unable to remove chart"
};

// Message related error messages
export const messageErrors = {
  DELETE_ERROR: "Could not delete message"
};

// Role management related error messages
export const roleErrors = {
  FETCH_ERROR: "Unable to fetch roles",
  UPDATE_ERROR: "Unable to update role",
  REMOVE_USER_ERROR: "Unable to remove user",
  FETCH_PERMISSIONS_ERROR: "Unable to fetch permissions",
  UPDATE_PERMISSION_ERROR: "Unable to update permission",
  REMOVE_PERMISSION_ERROR: "Unable to remove permission",
  ADD_CUSTOM_ROLE_ERROR: "Unable to add custom role",
  DELETE_CUSTOM_ROLE_ERROR: "Unable to delete custom role"
};

// Filter related error messages
export const filterErrors = {
  DUPLICATE_ERROR: "Filter {name} already exists",
  SAVE_ERROR: "Error in saving filter {name}"
};

// File related error messages
export const fileErrors = {
  UPLOAD_DISABLED: "Your org has disabled file uploads",
  UPLOAD_ERROR: "Error in uploading file please try again",
  CSV_UPLOAD_ERROR: "Failed to upload csv file",
  MULTIPLE_FILES_ERROR: "Cannot upload multiple files to single file field",
  MS365_AUTH_ERROR: "Not authorized with Microsoft 365",
  MS365_DISABLED_ERROR: "Integration is not enabled"
};

// Organization related error messages
export const orgErrors = {
  ALREADY_EXISTS: "org already exists",
  CREATE_ERROR: "Unable to create new org",
  UPDATE_ERROR: "Unable to update the organization",
  DELETE_DOMAIN_ERROR: "Unable to delete domain"
};

// Chart related error messages
export const chartErrors = {
  CREATE_ERROR: "Unable to create chart",
  UPDATE_ERROR: "Unable to update chart",
  DELETE_ERROR: "Unable to delete chart",
  FETCH_ERROR: "Failed to fetch chart",
  COPY_URL_ERROR: "Unable to copy chart URL",
  REFRESH_ERROR: "Refreshed chart data not available",
  GET_DATA_ERROR: "Unable to get chart data"
};

// Section related error messages
export const sectionErrors = {
  CREATE_ERROR: "Unable to create new section",
  UPDATE_ERROR: "Unable to update section",
  DELETE_ERROR: "Unable to delete the section",
  ORDER_ERROR: "Unable to change order of sections"
};

// User segment related error messages
export const segmentErrors = {
  EMPTY_TITLE_ERROR: "Cannot create user segment with empty title",
  SAVE_ERROR: "Cannot save user segment with empty title"
};

// Translation related error messages
export const translationErrors = {
  LOAD_LANGUAGES_ERROR: "Failed to load supported languages",
  SWITCH_LANGUAGE_ERROR: "Failed to switch language"
};

// Localforage related errors
export const localForageErrors = {
  FAILED_TO_GET_VALUE: "Failed to get value from indexedDB: "
};

export const aiErrors = {
  UNABLE_TO_GENERATE_AI_SUGGESTION:
    "Unable to generate AI suggestions. Please check your field settings."
};

export const getServerErrorConfig = actionType => {
  const configs = {
    GET_CURRENT_ORG_FAILURE: {
      description:
        "Your last visited organization is no longer accessible. Please select another organization from the list below. If no organizations are available, please contact your administrator."
    },

    SERVER_AUTH_FAILURE: {
      description:
        "Unable to connect to Unifize servers. Please try refreshing the page. If the problem persists, please try again later or contact support."
    },

    SEND_AUTH_TOKEN_FAILURE: {
      description:
        "Your session has expired. Please select another organization from the list below, or login again. If the issue continues, please contact support."
    },

    LOAD_CHATROOMS_FAILURE: {
      description:
        "We encountered an error while loading your conversations. Please refresh the page. If the problem persists, please contact support."
    },

    SRW_SERVER_AUTH_FAILURE: {
      description:
        "Your access link may have expired or is invalid. Please request a new access link from your administrator or contact support for assistance."
    },

    UNKNOWN_ERROR: {
      description:
        "An unexpected error occurred. Our team has been notified. Please try selecting another organization from the list below, or refresh the page. If the issue persists, please contact support."
    }
  };

  return configs[actionType] || configs.UNKNOWN_ERROR;
};
